var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuView = function SvgIconMenuView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.5c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5Z",
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.25A4.252 4.252 0 0 1 8.25 12a4.252 4.252 0 0 1 4.25-4.25A4.252 4.252 0 0 1 16.75 12a4.252 4.252 0 0 1-4.25 4.25Z",
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.113 9.852a.677.677 0 0 1-.529.81c-.383.077-.71.3-.897.612-.202.348-.244.775-.104 1.25a.677.677 0 0 1-.47.845.698.698 0 0 1-.856-.476c-.245-.838-.167-1.662.244-2.334a2.724 2.724 0 0 1 1.79-1.24.699.699 0 0 1 .822.533Z",
    fill: "url(#icon_menu_view_svg__a)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_menu_view_svg__a",
    x1: 11.253,
    y1: 10.076,
    x2: 11.604,
    y2: 14.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })))));
};
export default SvgIconMenuView;